/**
 * QUALITY CONTROL STORE
 */

import api from "Api";

const state = {
    page: {},
    dashboard_quality_control: null,
    available_batches: null,
    current_qc: null,
    quality_control: null,
    quality_control_filter: {
        search: "",
        furnace: null,
        page_size: 0,
        page_num: 1,
    },
};

// getters
const getters = {};

// actions
const actions = {
    async fetchQualityControl({ rootState, commit }, payload) {
        try {
            let body = "";

            if (payload.body) {
                switch (payload.method) {
                    case "post":
                    case "put":
                    case "patch":
                        body = JSON.stringify(payload.body);
                        break;
                    default:
                        body = payload.body;
                }
            }

            let response;

            switch (payload.method) {
                case "post":
                    response = await api.post(payload.url, body);

                    break;
                case "put":
                    response = await api.put(payload.url, body);

                    break;
                case "patch":
                    response = await api.patch(payload.url, body);

                    break;
                case "delete":
                    response = await api.delete(payload.url, {
                        params: body,
                    });

                    break;
                case "get":
                default:
                    response = await api.get(payload.url, {
                        params: body,
                    });
            }

            if (typeof response !== "undefined") {
                if (response.data && response.data.page) {
                    commit("commitQualityControl", {
                        property: "page",
                        with: response.data.page,
                    });
                }

                let dataPath = payload.dataProperty ? payload.dataProperty.split(".") : [];
                let possibleData = null;
                if (dataPath.length > 0) {
                    let data = response.data;
                    for (let i = 0; i < dataPath.length; i++) {
                        data = data[dataPath[i]];
                    }
                    possibleData = data;
                }
                commit("setQualityControl", {
                    property: payload.stateProperty,
                    with: payload.dataProperty ? possibleData : response.data.quality_control || [],
                });

                // let split_state = payload.stateProperty ? (payload.stateProperty || "").split("|") || [] : [];
                // let split_data = payload.dataProperty ? (payload.dataProperty || "").split("|") || [] : [];
                // split_state.forEach((ss, i) => {
                //     let sd = split_data[i] || ss;
                //     if (payload.commit) {
                //         commit("commitQualityControl", {
                //             property: ss,
                //             with: _.get(response.data, sd),
                //             id: payload.id,
                //             pk: payload.pk,
                //         });
                //         if (payload.localStorage) {
                //             localStorage.setItem(ss, JSON.stringify(_.get(response.data, sd)));
                //         }
                //     }
                //     if (payload.mutate) {
                //         commit("mutateQualityControl", {
                //             property: ss,
                //             with: _.get(response.data, sd),
                //             method: payload.method,
                //             id: payload.id,
                //             pk: payload.pk,
                //         });
                //     }
                // });
                return response.data;
            } else {
                return;
            }
        } catch (error) {
            throw error;
        }
    },
};

// mutations
const mutations = {
    commitQualityControl(state, payload) {
        if (state[payload.property] && Array.isArray(state[payload.property]) && payload.pk && payload.id) {
            let curr_index = state[payload.property].findIndex((obj) => obj[payload.pk] == payload.id);
            let property_array = state[payload.property];
            if (property_array && curr_index > -1) property_array.splice(curr_index, 1, payload.with || null);
        } else {
            _.set(state, payload.property, payload.with || null);
        }
    },
    mutateQualityControl(state, payload) {
        if (payload.method == "post" && payload.with) {
            state[payload.property].push(payload.with);
        } else if (payload.method == "patch" && payload.property && payload.with && payload.pk) {
            let curr_item = state[payload.property][state[payload.property].findIndex((obj) => obj[payload.pk] == payload.with[payload.pk])];
            for (const key in payload.with) if (key in curr_item) curr_item[key] = payload.with[key];
        } else if (payload.method == "delete" && payload.property && payload.pk && payload.id) {
            let curr_item = _.get(state, payload.property);
            curr_item.splice(
                curr_item.findIndex((obj) => obj[payload.pk] == payload.id),
                1
            );
        }
    },
    setQualityControl(state, payload) {
        state[payload.property] = payload.with || null;
    },
    resetQualityControl(state) {
        state.page = {};
        state.dashboard_quality_control = null;
        state.available_batches = null;
        state.current_qc = null;
        state.quality_control = JSON.parse(localStorage.getItem("quality_control")) || null;
        state.quality_control_filter = {
            search: "",
            furnace: null,
            page_size: 0,
            page_num: 1,
        };
    },
};

export default {
    state,
    getters,
    actions,
    mutations,
};
